function Head() {
  return (
    <header>
      <h1>Students Testimonials</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur. Tempus tincidunt etiam eget elit
        id imperdiet et. Cras eu sit dignissim lorem nibh et. Ac cum eget
        habitasse in velit fringilla feugiat senectus in.
      </p>
    </header>
  );
}

export default Head;
